import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDDisplayText } from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDDisplayText,
    _customProps: { size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['body'], {
    _component: () => withComponentArray(FDBodyText),
    _customProps: { size: 'md', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['disclaimerText'], {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
      color: 'textDisabled',
    },
  }, overrideReadOnly);
